import React from 'react';
import PropTypes from 'prop-types';
import {ButtonGroup} from 'reactstrap';
import classNames from 'classnames';
import apiBarcode from '../../services/api/apiBarcode';
import parseGGDriver from '../helpers/parseGGDriver';
import ListItemsNote from './ListItemsNote';
import {Link} from 'react-router-dom';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import MarkAsArchived from "./MarkAsArchived"
import ProductionStatus from "./ProductionStatus"
import {generateLabelShip} from "../../services/api/apiNextBarcode"
import {pushNewItemHistory} from "../../services/api/apiItemHistory";

class ListItemsItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingGenerate: false,
            isLoadingDelete: false,
            isLoadingPrint: false,
            isLoadingShip: false,
            isLoadingDuplicate: false
        };
    }

    _renderIconGenerate = () => {
        console.log(this.state.isLoadingGenerate)
        return this.state.isLoadingGenerate ? <i className='icon-spinner2 spinner ml-3'/> : <i className='icon-barcode2 text-primary ml-3' onClick={this._handleClickGenerate}/>
    };

    _handleClickGenerate = async () => {
        try {
            this.setState({isLoadingGenerate: true});
            const {item, reloadItems} = this.props;
            console.log(item)

            const payload = {
                status: item.gen_at !== undefined ? 'regenerated' : 'generated'
            }

            const {data, success, message} = await generateLabelShip(item._id, payload)
            if (!success) {
                this.setState({isLoadingGenerate: false});
                throw new Error(message)
            }

            const {labelDetails} = data
            const {partnerTrackingNumber} = labelDetails

            this.setState({
                isLoadingGenerate: false
            }, async () => {
                await reloadItems()

                return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                    event_key: 'generate_label',
                    event_description: 'Generate label from single action.',
                    event_meta: {
                        source: 'single_generate_label',
                        label: partnerTrackingNumber
                    }
                })
            });
        } catch (e) {
            alert(e.message);
        }
    };

    _renderIconDelete = () => {
        if (this.state.isLoadingDelete)
            return <i className='icon-spinner2 spinner ml-3'/>;
        return <i className='icon-bin text-danger ml-3' onClick={this._handleClickDelete}/>;
    };

    _handleClickDelete = async () => {
        const r = window.prompt('Bạn có chắc chắn muốn XÓA đơn hàng này?\nĐơn hàng đã XÓA sẽ không thể khôi phục lại\nGõ "ok" và bấm OK để xóa');
        // console.log(r)
        if (r !== 'ok') {
            console.log('bạn phải gõ "ok" để xóa đơn hàng')
            return;
        }

        this.setState({isLoadingDelete: true});

        try {
            const {item, reloadItems} = this.props;

            const resDelete = await apiBarcode.deleteBarcode(item._id);

            const {success, message} = resDelete.data;
            if (!success) throw new Error(message);

            await reloadItems();
        } catch (e) {
            alert(e.message);
        }

        this.setState({isLoadingDelete: false});
    };

    _handleClickEdit = () => {
        const {item, openModalEdit} = this.props;
        openModalEdit(item);
    };

    _handleClickEditCommitTime = () => {
        const {item, openModalEditCommitTime} = this.props;
        openModalEditCommitTime(item);
    }

    _handleClickEditProduct = () => {
        const {item, openModalEditProduct} = this.props;
        console.log(item)
        const {_id, pos, barcodeNumber, productId, mockUpFront, mockUpBack, designFront, designBack, size, color, type, quantity} = item;
        const product = {
            barcodeId: _id,
            pos,
            barcodeNumber,
            productId,
            mockUpFront,
            mockUpBack,
            designFront,
            designBack,
            size,
            color,
            type,
            quantity
        };

        openModalEditProduct(product);
    };

    _renderIconDuplicate = () => {
        if (this.state.isLoadingDuplicate)
            return <i className='icon-spinner2 spinner ml-3'/>;
        return <i className='icon-copy text-secondary ml-3' onClick={this._handleClickDuplicate}/>;
    };

    _handleClickDuplicate = async () => {
        const r = window.confirm('Bạn có chắc chắn muốn copy sản phẩm này?');
        if (!r) return;

        this.setState({isLoadingDuplicate: true});
        const {item, duplicateItem} = this.props;
        await duplicateItem(item._id);
        this.setState({isLoadingDuplicate: false});
    };

    _handleDeleteLabel = async () => {
        const r = window.confirm('Bạn có chắc chắn muốn xóa label này?');
        if (!r) return;

        try {
            const {item, reloadItems} = this.props;

            const resUpdated = await apiBarcode.updateBarcode(item._id, {labelDetails: null});
            const {success, message} = resUpdated.data;
            if (!success) throw new Error(message);

            await reloadItems();

            return pushNewItemHistory(`${item.barcodeNumber}_1`, {
                event_key: 'delete_label',
                event_description: `Delete label`,
                event_meta: {
                    source: 'single_delete_label',
                }
            })
        } catch (e) {
            alert(e.message);
        }

    };

    _convertDateOverTime = (time) => {
        const intTime = time * 24 * 60 * 60
        const total_minutes = parseInt(Math.floor(intTime / 60));
        const total_hours = parseInt(Math.floor(total_minutes / 60));
        const days = parseInt(Math.floor(total_hours / 24)) !== 0 ? parseInt(Math.floor(total_hours / 24)) + 'd ' : '';

        const minutes = parseInt(total_minutes % 60) !== 0 ? parseInt(total_minutes % 60) + 'm ' : '';
        const hours = parseInt(total_hours % 24) !== 0 ? parseInt(total_hours % 24) + 'h ' : '';

        return days + hours + minutes;
    }

    _detectChecked = () => {
        const {item, selectedItems} = this.props

        return Array.isArray(selectedItems) && selectedItems.includes(item._id)
    }

    _handleChange = () => {
        const isChecked = this._detectChecked()
        const {item, onChangeSelected} = this.props

        onChangeSelected(item._id, !isChecked)
    }

    render() {
        const {item, reloadItems} = this.props;
        const {isSubitem, multiLabel, hasLabel, orderLabelDetails, order3d, order3d_at, gen_at, production_status} = item;
        const {partnerTrackingNumber, url, 'created': track_created} = item.labelDetails || {};
        const {'partnerTrackingNumber': orderTrackingNumber, 'url': orderTrackingUrl, 'created': orderTrackingCreated} = item.hasOwnProperty('orderLabelDetails') ? orderLabelDetails : {'partnerTrackingNumber': ''}
        const timeGenTracking = track_created ? new Date(track_created).toLocaleString('en-GB') : '';
        const timeGenOrderTracking = (orderTrackingCreated || gen_at) ? new Date(orderTrackingCreated || gen_at).toLocaleString('en-GB') : '';
        const timeText = item.created ? new Date(item.created).toLocaleString('en-GB') : '';
        const shippedAt = item.shipped_at ? new Date(item.shipped_at).toLocaleString('en-GB') : '';
        const printedAt = item.printed_at ? new Date(item.printed_at).toLocaleString('en-GB') : '';
        const shippedIp = item.shipped_ip || '';
        const printedIp = item.printed_ip || '';

        const productStatus = item.productStatus || 'error';
        const {box_id, boxed_at} = item;
        const classNameItem = classNames({
            ListItemsItem: true,
            BorderNone: isSubitem,
            'text-success': productStatus === 'completed' && item.status !== 'error',
            disabled: production_status === 'packaged',
            disabledCancel: production_status === 'cancelled' || production_status === 'on-hold',
            'bg-dark': item.status === 'error',
            'text-warning': item.status === 'error'
        });

        const mockUpFront = parseGGDriver(item.mockUpFront);
        const mockUpBack = parseGGDriver(item.mockUpBack);
        const designFront = parseGGDriver(item.designFront);
        const designBack = parseGGDriver(item.designBack);

        const boxed_date = new Date(boxed_at).toLocaleDateString()
        const storename = item.hasOwnProperty('storename') ? item.storename : ''
        const canViewStore = this.props.canViewStore
        const tool3d_support_type = ['CANVAS', 'POSTER', 'TSHIRT_3D', 'SWEATSHIRT_3D', 'HOODIE_3D', 'ZIP HOODIE 3D', 'TSHIRT_02', 'SW_18', 'HD_18', 'ZIP_HD_18']
        const require_tool3d = (tool3d_support_type.indexOf(item.type) !== -1)
        const className3D = classNames({
            'font-size-ms': true,
            'text-success': order3d === true,
            'text-muted': typeof order3d === 'undefined',
            'text-danger': order3d === false
        });
        const order3d_time = order3d_at ? (new Date(order3d_at).toLocaleString('en-GB', {
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        })) : ''
        const total = item.items.length
        const classNamePrinted = classNames({
            'text-success': printedAt,
            'font-size-sm': true
        })

        const isChecked = this._detectChecked()

        return (
            <tr className={classNameItem}>
                <td className="notDisableCancel">
                    {
                        (!isSubitem && item.production_status !== 'labelled' && item.production_status !== 'packaged') && (
                            <input type='checkbox' className='inputCheckboxSelected'
                                   id={`OrderColSelection_${item.orderNumber}`}
                                   onChange={this._handleChange}
                                   checked={isChecked}
                            />
                        )
                    }
                </td>
                {
                    !isSubitem ? <td className="OrderNumber">
                            <div className='text-primary'> #{item.barcodeNumber}</div>
                            <div><small>{item.packageName || item.orderNumber}</small></div>
                            {canViewStore && <div className="text-secondary"><small>{storename}</small></div>}
                            <ListItemsNote key={item._id} id={'PopoverNote_' + item._id} note={item.note}
                                           itemId={item._id}/>
                        </td> :
                        <td/>
                }
                <td>
                    {
                        <span className="font-weight-bold">{item.pos}/{total}</span>
                    }
                    {
                        require_tool3d &&
                        <div className={className3D}>
                            <span className="icon-image2 icon-sxx mr-1"/>{order3d_time}
                        </div>
                    }
                    {
                        printedAt &&
                        <div className={classNamePrinted}>
                            <span className="badge badge-mark border-success mr-1"/>{printedAt}
                        </div>
                    }
                    {
                        printedIp &&
                        <div className="text-muted font-size-sm">
                            <span className="badge badge-mark border-danger mr-1"/>
                            {printedIp}
                        </div>
                    }
                </td>
                <td>
                    {mockUpFront && <LazyLoadImage className='zoom' src={mockUpFront} alt='Link'/>}
                </td>
                <td>
                    {mockUpBack && <LazyLoadImage className='zoom' src={mockUpBack} alt='Link'/>}
                </td>
                <td className="notDisableCancel">
                    {designFront &&
                    <a href={designFront} target='_blank' rel='noopener noreferrer'><u>F</u>ront<br/>Mặt TRƯỚC</a>}
                </td>
                <td className="notDisableCancel">
                    {designBack &&
                    <a href={designBack} target='_blank' rel='noopener noreferrer'><u>B</u>ack<br/>Mặt SAU</a>}
                </td>
                <td>
                    <p>Type: {item.type}</p>
                    <p>Color: {item.color}</p>
                    <p>Size: {item.size}</p>
                </td>
                {
                    !isSubitem ? <td>
                        <span className='d-block'>{item.name}</span>
                        <span className='d-block'>{item.address1}</span>
                        <span className='d-block'>{item.address2}</span>
                        <span className='d-block'>{item.city + ' ' + item.state + ' ' + item.postalCode}</span>
                        <span className='d-block'>{item.country}</span>
                    </td> : <td/>
                }
                <td className="notDisableCancel">
                    {
                        // !isSubitem && partnerTrackingNumber && !multiLabel &&
                        !isSubitem && orderTrackingNumber &&
                        <React.Fragment>
                            <a href={orderTrackingUrl} target='_blank'
                               rel="noopener noreferrer">{orderTrackingNumber}</a>&nbsp;
                            <a href={`https://webtrack.dhlglobalmail.com/?trackingnumber=${orderTrackingNumber}`}
                               target='_blank' rel="noopener noreferrer"><i className='icon-new-tab'/></a>
                            <i className='icon-cancel-square text-danger' onClick={this._handleDeleteLabel}/>
                            <br/><span title="Label created at">{timeGenOrderTracking}</span>
                        </React.Fragment>
                    }

                    {
                        !isSubitem && shippedAt && <div className="text-muted font-size-sm">
                            <span className="badge badge-mark border-success mr-1"/>
                            {shippedAt}
                        </div>
                    }
                    {
                        !isSubitem && shippedIp &&
                        <div className="text-muted font-size-sm">
                            <span className="badge badge-mark border-danger mr-1"/>
                            {shippedIp}
                        </div>
                    }
                    {
                        !isSubitem && box_id &&
                        <div>
                            <div>Box: {box_id} <Link to={'/boxes/' + box_id}>Xem thùng</Link></div>
                            <div>Boxed at: {boxed_date}</div>
                        </div>
                    }
                    {
                        multiLabel && hasLabel && partnerTrackingNumber &&
                        <React.Fragment>
                            <a href={url} target='_blank' rel="noopener noreferrer">{partnerTrackingNumber}</a>&nbsp;
                            <a href={`https://webtrack.dhlglobalmail.com/?trackingnumber=${partnerTrackingNumber}`}
                               target='_blank' rel="noopener noreferrer"><i className='icon-new-tab'/></a>
                            <br/><span>{timeGenTracking}</span>
                        </React.Fragment>
                    }
                </td>
                {
                    !isSubitem ?
                        <td>
                            {timeText}
                        </td> :
                        <td/>
                }
                <td>
                    {
                        (item.production_time !== undefined) && (
                            (item.production_time === null) ? (
                                <Link to={'/commitment-times'}><i className='icon-pencil text-success'/></Link>
                            ) : (
                                <div className={classNames("d-print-flex flex-column", item.production_time > item.commitment_time && 'text-danger')}>
                                    {(item.production_time !== undefined && item.production_time > 0) && this._convertDateOverTime(item.production_time)}
                                    / {(item.commitment_time !== undefined && item.commitment_time > 0) && this._convertDateOverTime(item.commitment_time)}
                                </div>
                            )
                        )
                    }
                </td>
                {
                    !isSubitem ?
                        <td className="notDisableCancel">
                            {production_status !== 'labelled' && (
                                <ButtonGroup>
                                    <i className='icon-pencil5 text-warning' onClick={this._handleClickEditProduct}/>
                                    {this._renderIconDuplicate()}
                                    <i className='icon-pencil text-success ml-3' onClick={this._handleClickEdit}/>
                                    {this._renderIconGenerate()}
                                    {/*{this._renderIconDelete()}*/}
                                </ButtonGroup>
                            )}
                            <div className="Bottom d-flex mt-2">
                                <MarkAsArchived reloadItems={reloadItems} item={item}/>
                                <ProductionStatus reloadItems={reloadItems} item={item}/>
                            </div>

                        </td> :
                        <td>
                            {production_status !== 'labelled' && (
                            <ButtonGroup>
                                <i className='icon-pencil5 text-warning' onClick={this._handleClickEditProduct}/>
                            </ButtonGroup>
                            )}
                        </td>
                }
            </tr>
        );
    }
}

ListItemsItem.propTypes = {
    index: PropTypes.number.isRequired,
    item: PropTypes.object.isRequired,
    reloadItems: PropTypes.func.isRequired,
    duplicateItem: PropTypes.func.isRequired
};

export default ListItemsItem;
